import { StarRate } from "@mui/icons-material";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // main
  mainIndex: [],
  selectedFromDate: null,
  selectedToDate: null,
  // selectedMonthFrom: null,
  // selectedMonthTo: null,
  // selectedDayFrom: null,
  // selectedDayTo: null,
  selectedYearFrom: null,
  selectedYearTo: null,
  addedIndexes: [],
  currentIndexId: null,
  mainFilterToggle: false,
  mainOrder: "2",
  mainWindowSize: "10",
  mainPeriodOfTime: [
    {
      label: "By day",
      checked: true,
      key: "same",
    },
    {
      label: "10 Days",
      checked: false,
      key: "days",
    },
    {
      label: "Month",
      checked: false,
      key: "month",
    },
    {
      label: "Range",
      checked: false,
      key: "range",
    },
  ],
  mainSummerizeOption: [
    {
      label: "Mean",
      checked: true,
      key: "mean",
    },
    {
      label: "Median",
      checked: false,
      key: "median",
    },
    {
      label: "Max",
      checked: false,
      key: "max",
    },
    {
      label: "Min",
      checked: false,
      key: "min",
    },
    {
      label: "Sum",
      checked: false,
      key: "sum",
    },
  ],

  mainTemporalMethod: [
    {
      label: "By pixel",
      checked: false,
      key: "pixel",
    },
    {
      label: "By image",
      checked: true,
      key: "image",
    },
  ],
  mainShortTermMonitoring: null,
  //current data
  currentAll: [],
  selectedFromDateCurrent: {},
  selectedToDateCurrent: {},
  // selectedDayFromCurrent: {},
  // selectedDayToCurrent: {},
  // selectedYearFromCurrent: {},
  // selectedYearToCurrent: {},
  addedIndexesCurrent: [],
  currentFilterToggle: false,
  currentOrder: "",
  currentWindowSize: "",

  // reference
  refToggle: false,
  uploadMaskToggle: false,
  RefIndex: [],
  selectedRef: {},
  rangePairs: [],
  values: [],
  refFromDate: {},
  refToDate: {},
  pinpointCoordinates: null,
  // refMonthFrom: {},
  // refMonthTo: {},
  // refDayFrom: {},
  // refDayTo: {},
  // refYearFrom: {},
  // refYearTo: {},
};
const MaskingSlicke = createSlice({
  name: "masking",
  initialState,
  reducers: {
    // current data
    setCurrentAll: (state, action) => {
      state.currentAll = action.payload;
    },
    setSelectedFromDateCurrent: (state, action) => {
      const { index, fromDate } = action.payload;
      const updatedItems = [...state.currentAll];
      updatedItems[index] = {
        ...updatedItems[index],
        from_date: fromDate,
      };
      state.currentAll = updatedItems;
    },
    setSelectedToDateCurrent: (state, action) => {
      const { index, toDate } = action.payload;
      console.log("to date:", toDate);
      const updatedItems = [...state.currentAll];
      updatedItems[index] = {
        ...updatedItems[index],
        to_date: toDate,
      };
      state.currentAll = updatedItems;
    },
    // setSelectedMonthFromCurrent: (state, action) => {
    //   const { index, monthFrom } = action.payload;
    //   const updatedItems = [...state.currentAll];
    //   updatedItems[index] = {
    //     ...updatedItems[index],
    //     monthFrom: monthFrom,
    //   };
    //   state.currentAll = updatedItems;
    // },
    // setSelectedMonthToCurrent: (state, action) => {
    //   const { index, monthTo } = action.payload;
    //   const updatedItems = [...state.currentAll];
    //   updatedItems[index] = {
    //     ...updatedItems[index],
    //     monthTo: monthTo,
    //   };
    //   state.currentAll = updatedItems;
    // },
    // setSelectedDayFromCurrent: (state, action) => {
    //   const { index, dayFrom } = action.payload;
    //   const updatedItems = [...state.currentAll];
    //   updatedItems[index] = {
    //     ...updatedItems[index],
    //     dayFrom: dayFrom,
    //   };
    //   state.currentAll = updatedItems;
    // },
    // setSelectedDayToCurrent: (state, action) => {
    //   const { index, dayTo } = action.payload;
    //   const updatedItems = [...state.currentAll];
    //   updatedItems[index] = {
    //     ...updatedItems[index],
    //     dayTo: dayTo,
    //   };
    //   state.currentAll = updatedItems;
    // },
    // setSelectedYearFromCurrent: (state, action) => {
    //   const { index, yearFrom } = action.payload;
    //   const updatedItems = [...state.currentAll];
    //   updatedItems[index] = {
    //     ...updatedItems[index],
    //     yearFrom: yearFrom,
    //   };
    //   state.currentAll = updatedItems;
    // },

    // setSelectedYearToCurrent: (state, action) => {
    //   const { index, yearTo } = action.payload;
    //   const updatedItems = [...state.currentAll];
    //   updatedItems[index] = {
    //     ...updatedItems[index],
    //     yearTo: yearTo,
    //   };
    //   state.currentAll = updatedItems;
    // },
    setFilterToggleCurrent: (state, action) => {
      const { index } = action.payload;
      const updatedItems = [...state.currentAll];
      updatedItems[index] = {
        ...updatedItems[index],
        filterToggle: !updatedItems[index].filterToggle,
      };
      state.currentAll = updatedItems;
    },

    setWindowSizeCurrent: (state, action) => {
      const { index, window } = action.payload;
      const updatedItems = [...state.currentAll];
      updatedItems[index] = {
        ...updatedItems[index],
        window: window,
      };
      state.currentAll = updatedItems;
    },
    setOrderCurrent: (state, action) => {
      const { index, order } = action.payload;
      const updatedItems = [...state.currentAll];
      updatedItems[index] = {
        ...updatedItems[index],
        order: order,
      };
      state.currentAll = updatedItems;
    },

    // main index
    setMainShortTermMonitoring: (state, action) => {
      state.mainShortTermMonitoring = action.payload;
    },
    setCurrentIndexId: (state, action) => {
      state.currentIndexId = action.payload;
    },

    setMainPeriodOfTime: (state, action) => {
      const index = action.payload;
      const updatedMainPeriodOfTime = state.mainPeriodOfTime.map(
        (item, idx) => ({
          ...item,
          checked: idx === index,
        })
      );
      state.mainPeriodOfTime = updatedMainPeriodOfTime;
    },

    setMainTemporalMethod: (state, action) => {
      const index = action.payload;
      const updatedMainPeriodOfTime = state.mainTemporalMethod.map(
        (item, idx) => ({
          ...item,
          checked: idx === index,
        })
      );
      state.mainTemporalMethod = updatedMainPeriodOfTime;
    },

    setMainSummerizeOption: (state, action) => {
      const index = action.payload;
      const updatedMainSummerizeOptions = state.mainSummerizeOption.map(
        (item, idx) => ({
          ...item,
          checked: idx === index,
        })
      );
      state.mainSummerizeOption = updatedMainSummerizeOptions;
    },

    setMainIndex: (state, action) => {
      console.log(action.payload);
      state.mainIndex = action.payload;
    },

    setSelectedFromDate: (state, action) => {
      state.selectedFromDate = action.payload;
    },
    setSelectedToDate: (state, action) => {
      state.selectedToDate = action.payload;
    },
    // setSelectedMonthFrom: (state, action) => {
    //   state.selectedMonthFrom = action.payload;
    // },
    // setSelectedMonthTo: (state, action) => {
    //   state.selectedMonthTo = action.payload;
    // },
    // setSelectedDayFrom: (state, action) => {
    //   state.selectedDayFrom = action.payload;
    // },
    // setSelectedDayTo: (state, action) => {
    //   state.selectedDayTo = action.payload;
    // },
    setSelectedYearFrom: (state, action) => {
      state.selectedYearFrom = action.payload;
    },

    setSelectedYearTo: (state, action) => {
      state.selectedYearTo = action.payload;
    },
    setmainFilterToggle: (state) => {
      state.mainFilterToggle = !state.mainFilterToggle;
    },

    setmainWindowSize: (state, action) => {
      state.mainWindowSize = action.payload;
    },
    setmainOrder: (state, action) => {
      state.mainOrder = action.payload;
    },

    setAddedIndexesInit: (state, action) => {
      state.addedIndexes = [
        ...state.addedIndexes,
        {
          id: null,
          name: "",
          from_date: state.selectedFromDate,
          to_date: state.selectedToDate,
          // monthFrom: state.selectedMonthFrom,
          // dayFrom: state.selectedDayFrom,
          // monthTo: state.selectedMonthTo,
          // dayTo: state.selectedDayTo,
          yearFrom: state.selectedYearFrom,
          yearTo: state.selectedYearTo,
          filterToggle: state.mainFilterToggle,
          order: state.mainOrder,
          window: state.mainWindowSize,
          periodOfTime: state.mainPeriodOfTime,
          summerizeOptions: state.mainSummerizeOption,
          shortTermMonitoring: state.mainShortTermMonitoring,
          temporalMethod: state.mainTemporalMethod,
        },
      ];
    },
    deleteOneAddIndex: (state, action) => {
      const { index } = action.payload;
      const updatedAddedIndexes = state.addedIndexes.filter(
        (_, i) => i !== index
      );

      state.addedIndexes = updatedAddedIndexes;
    },
    setAddedIndexesName: (state, action) => {
      const { index, name } = action.payload;

      const updatedIndexes = [...state.addedIndexes];

      updatedIndexes[index] = {
        ...updatedIndexes[index],
        name: name,
      };

      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesId: (state, action) => {
      const { index, id } = action.payload;

      const updatedIndexes = [...state.addedIndexes];

      updatedIndexes[index] = {
        ...updatedIndexes[index],
        id: id,
      };

      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesPeriodOfTime: (state, action) => {
      const { index, index2, periodOfTime } = action.payload;
      const updatedIndexes = [...state.addedIndexes];

      updatedIndexes[index2] = {
        ...updatedIndexes[index2],
        periodOfTime: periodOfTime
          ? [...periodOfTime]
          : updatedIndexes[index2].periodOfTime.map((item, idx) => ({
              ...item,
              checked: idx === index,
            })),
      };

      state.addedIndexes = updatedIndexes;
    },

    setAddedIndexesSummerizeOptions: (state, action) => {
      const { index, index2, summerizeOptions } = action.payload;
      const updatedIndexes = [...state.addedIndexes];

      updatedIndexes[index2] = {
        ...updatedIndexes[index2],
        summerizeOptions: summerizeOptions
          ? [...summerizeOptions]
          : updatedIndexes[index2].summerizeOptions.map((item, idx) => ({
              ...item,
              checked: idx === index,
            })),
      };

      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesTemporalMethod: (state, action) => {
      const { index, index2, temporalMethod } = action.payload;
      const updatedIndexes = [...state.addedIndexes];

      updatedIndexes[index2] = {
        ...updatedIndexes[index2],
        temporalMethod: temporalMethod
          ? [...temporalMethod]
          : updatedIndexes[index2].temporalMethod.map((item, idx) => ({
              ...item,
              checked: idx === index,
            })),
      };

      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesOrder: (state, action) => {
      const { index, order } = action.payload;

      const updatedIndexes = [...state.addedIndexes];

      updatedIndexes[index] = {
        ...updatedIndexes[index],
        order: order,
      };

      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesDerivative: (state, action) => {
      const { index, derivative } = action.payload;

      const updatedIndexes = [...state.addedIndexes];

      updatedIndexes[index] = {
        ...updatedIndexes[index],
        derivative: derivative,
      };

      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesWindow: (state, action) => {
      const { index, window } = action.payload;

      const updatedIndexes = [...state.addedIndexes];

      updatedIndexes[index] = {
        ...updatedIndexes[index],
        window: window,
      };

      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesShortTerm: (state, action) => {
      console.log("action.payload", action);
      const { index, short } = action.payload;
      const updatedIndexes = [...state.addedIndexes];

      updatedIndexes[index] = {
        ...updatedIndexes[index],
        shortTermMonitoring: short,
      };

      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesFilterToggle: (state, action) => {
      const { index } = action.payload;

      const updatedIndexes = [...state.addedIndexes];
      console.log("state.addedIndexes", state.addedIndexes);

      updatedIndexes[index] = {
        ...updatedIndexes[index],
        filterToggle: !state.addedIndexes[index].filterToggle,
      };

      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesFilter: (state, action) => {
      const { index, filter } = action.payload;

      const updatedIndexes = [...state.addedIndexes];

      updatedIndexes[index] = {
        ...updatedIndexes[index],
        filter: filter,
      };

      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesFromDate: (state, action) => {
      const { index, fromDate } = action.payload;

      const updatedIndexes = [...state.addedIndexes];

      updatedIndexes[index] = {
        ...updatedIndexes[index],
        from_date: fromDate,
      };
      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesToDate: (state, action) => {
      const { index, toDate } = action.payload;

      const updatedIndexes = [...state.addedIndexes];

      updatedIndexes[index] = {
        ...updatedIndexes[index],
        to_date: toDate,
      };
      state.addedIndexes = updatedIndexes;
    },
    // setAddedIndexesmonthFrom: (state, action) => {
    //   const { index, monthFrom } = action.payload;

    //   const updatedIndexes = [...state.addedIndexes];

    //   updatedIndexes[index] = {
    //     ...updatedIndexes[index],
    //     monthFrom: monthFrom,
    //   };

    //   state.addedIndexes = updatedIndexes;
    // },
    // setAddedIndexesmonthTo: (state, action) => {
    //   const { index, monthTo } = action.payload;

    //   const updatedIndexes = [...state.addedIndexes];

    //   updatedIndexes[index] = {
    //     ...updatedIndexes[index],
    //     monthTo: monthTo,
    //   };

    //   state.addedIndexes = updatedIndexes;
    // },
    // setAddedIndexesdayFrom: (state, action) => {
    //   const { index, dayFrom } = action.payload;

    //   const updatedIndexes = [...state.addedIndexes];

    //   updatedIndexes[index] = {
    //     ...updatedIndexes[index],
    //     dayFrom: dayFrom,
    //   };

    //   state.addedIndexes = updatedIndexes;
    // },
    // setAddedIndexesdayTo: (state, action) => {
    //   const { index, dayTo } = action.payload;

    //   const updatedIndexes = [...state.addedIndexes];

    //   updatedIndexes[index] = {
    //     ...updatedIndexes[index],
    //     dayTo: dayTo,
    //   };

    //   state.addedIndexes = updatedIndexes;
    // },
    setAddedIndexesYearTo: (state, action) => {
      console.log("action.payload/yearTo", action);
      const { index, yearTo } = action.payload;

      const updatedIndexes = [...state.addedIndexes];

      updatedIndexes[index] = {
        ...updatedIndexes[index],
        yearTo: yearTo,
      };
      state.selectedYearTo = yearTo;
      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesYearFrom: (state, action) => {
      console.log("action.payload/yearFrom", action);
      const { index, yearFrom } = action.payload;
      console.log("YEEEAR FROOOM", action.payload);

      const updatedIndexes = [...state.addedIndexes];

      updatedIndexes[index] = {
        ...updatedIndexes[index],
        yearFrom: yearFrom,
      };
      state.selectedYearFrom = yearFrom;
      state.addedIndexes = updatedIndexes;
    },

    // reference index
    setRefIndex: (state, action) => {
      state.RefIndex = action.payload;
    },

    // setRefMonthFrom: (state, action) => {
    //   state.refMonthFrom = action.payload;
    // },
    setRefFromDate: (state, action) => {
      state.refFromDate = action.payload;
    },
    setRefToDate: (state, action) => {
      state.refToDate = action.payload;
    },
    clearRefDates: (state) => {
      state.refFromDate = "";
      state.refToDate = "";
    },
    clearSelectedDates: (state) => {
      state.selectedFromDate = "";
      state.selectedToDate = "";
    },
    setPinpointCoordinates: (state, action) => {
      state.pinpointCoordinates = action.payload;
    },
    // setRefMonthTo: (state, action) => {
    //   state.refMonthTo = action.payload;
    // },
    // setRefDayFrom: (state, action) => {
    //   state.refDayFrom = action.payload;
    // },
    // setRefDayTo: (state, action) => {
    //   state.refDayTo = action.payload;
    // },
    // setRefYearFrom: (state, action) => {
    //   state.refYearFrom = action.payload;
    // },

    // setRefYearTo: (state, action) => {
    //   state.refYearTo = action.payload;
    // },
    setSelectedRef: (state, action) => {
      const { index, path } = action.payload;
      console.log(path);
      state.selectedRef = {
        ...state.selectedRef,
        [state.RefIndex[index]]: [path],
      };
    },
    setRangePairs: (state, action) => {
      state.rangePairs = action.payload;
    },
    setValues: (state, action) => {
      state.values = action.payload;
    },
    setRefToggle: (state) => {
      state.refToggle = !state.refToggle;
    },
    setUploadMaskToggle: (state) => {
      state.uploadMaskToggle = !state.uploadMaskToggle;
    },
  },
  extraReducers: (builder) => {
    // Handle reset action
    builder.addCase("RESET", () => initialState);
  },
});

export const {
  //current
  setCurrentAll,
  setFilterToggleCurrent,
  setOrderCurrent,
  // setSelectedDayFromCurrent,
  // setSelectedDayToCurrent,
  // setSelectedMonthFromCurrent,
  // setSelectedMonthToCurrent,
  // setSelectedYearFromCurrent,
  // setSelectedYearToCurrent,
  setWindowSizeCurrent,

  // main index
  setMainTemporalMethod,
  setMainShortTermMonitoring,
  setAddedIndexesSummerizeOptions,
  setAddedIndexesPeriodOfTime,
  setMainSummerizeOption,
  setMainPeriodOfTime,
  setAddedIndexesWindow,
  setmainDerivative,
  setmainOrder,
  setmainWindowSize,
  setAddedIndexesDerivative,
  setAddedIndexesOrder,
  setAddedIndexesFilter,
  setAddedIndexesFilterToggle,
  setAddedIndexesId,
  setmainFilterToggle,
  setmainFilter,
  deleteOneAddIndex,
  setAddedIndexesYearFrom,
  setAddedIndexesYearTo,
  // setAddedIndexesdayFrom,
  // setAddedIndexesdayTo,
  // setAddedIndexesmonthFrom,
  // setAddedIndexesmonthTo,
  // setSelectedDayFrom,
  // setSelectedDayTo,
  // setSelectedMonthFrom,
  // setSelectedMonthTo,
  setSelectedYearFrom,
  setSelectedYearTo,
  cleatSelectionMain,
  setSelectedMainByMonth,
  setStatSelect,
  setSelectedMain,
  setSelectedMainInit,
  setmainIndexPaths,
  setmainIndexPathsInit,
  setMainIndex,
  setSelectByMonthInit,
  setSelectByMonth,
  setmainDateRangeInit,
  setmainDateRange,
  setmainIndexLoadingInit,
  setmainIndexLoading,
  setAddedIndexesInit,
  setAddedIndexesName,
  setAddedIndexesShortTerm,
  setAddedIndexesTemporalMethod,
  setCurrentIndexId,
  setPinpointCoordinates,

  // ref index
  setValues,
  setRangePairs,

  setRefIndex,

  setSelectedRef,
  setSelectedRefInit,

  setRefToggle,
  setUploadMaskToggle,
  // setRefDayFrom,
  // setRefDayTo,
  // setRefMonthFrom,
  setRefFromDate,
  setRefToDate,
  // setRefMonthTo,
  setSelectedFromDateCurrent,
  setSelectedToDateCurrent,
  setSelectedFromDate,
  setSelectedToDate,
  setAddedIndexesFromDate,
  setAddedIndexesToDate,
  // setRefYearFrom,
  // setRefYearTo,
  clearRefDates,
  clearSelectedDates,
} = MaskingSlicke.actions;

export default MaskingSlicke.reducer;
